import { LRUCache } from "../structures/LRUCache.js";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class CacheStore {
  constructor() {
    __publicField(this, "cacheStore", /* @__PURE__ */ new WeakMap());
  }
  get(environment, entry, expression) {
    let caches = this.cacheStore.get(environment);
    if (caches === void 0) {
      this.cacheStore.set(environment, caches = this.createEntryPointCache());
    }
    return caches[entry].get(expression);
  }
  set(environment, entry, expression, value) {
    let caches = this.cacheStore.get(environment);
    if (caches === void 0) {
      this.cacheStore.set(environment, caches = this.createEntryPointCache());
    }
    caches[entry].set(expression, value);
  }
  createEntryPointCache() {
    return {
      qualifiedEntityList: new LRUCache(50),
      qualifiedFieldList: new LRUCache(50),
      qualifiedSingleEntity: new LRUCache(50),
      unconstrainedQualifiedEntityList: new LRUCache(10),
      unconstrainedQualifiedSingleEntity: new LRUCache(10),
      relativeSingleField: new LRUCache(1e3),
      relativeSingleEntity: new LRUCache(500),
      relativeEntityList: new LRUCache(500),
      uniqueWhere: new LRUCache(100),
      filter: new LRUCache(100),
      orderBy: new LRUCache(50),
      taggedMap: new LRUCache(50)
    };
  }
}
export {
  CacheStore
};
//# sourceMappingURL=CacheStore.js.map
